import { GetterTree } from "vuex";
import { MasterState } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<MasterState, RootState> = {};

export default getters;
